import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;

  padding-top: 88px;

  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.greys.lighter};
`;

export const Content = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
`;
